import { Stack } from '@mui/material';
import { FlowLimitReturnType } from 'flow-schema';

import { BlockSelectField } from '../../ConfigFields/SelectField.tsx';
import { BlockTextField } from '../../ConfigFields/TextField.tsx';
import { useSelectedNodeField } from '../../ConfigFields/useSelectedNodeField';

const LimitReturnTypeMapping: Record<FlowLimitReturnType, string> = {
  [FlowLimitReturnType.List]: 'Return All',
  [FlowLimitReturnType.LimitedList]: 'Return N Items',
  [FlowLimitReturnType.FirstObject]: 'First Match',
};

export function LimitBlockFormFields() {
  const { value: returnType } = useSelectedNodeField<string>('config.limitConfig.returnType');

  return (
    <Stack gap={2}>
      <BlockSelectField
        fieldName="config.limitConfig.returnType"
        label="Return type"
        options={Object.values(FlowLimitReturnType).map((entry) => ({
          label: LimitReturnTypeMapping[entry],
          value: entry,
        }))}
        helperText="Return a list of objects or the first object in the list"
      />
      {returnType === FlowLimitReturnType.LimitedList && (
        <BlockTextField
          fieldName="config.limitConfig.limit"
          label="Limit"
          type="number"
          slotProps={{
            htmlInput: {
              min: 1,
              step: 1,
            },
          }}
          helperText="The maximum number of objects to return"
        />
      )}
      {(returnType === FlowLimitReturnType.LimitedList ||
        returnType === FlowLimitReturnType.FirstObject) && (
        <BlockTextField
          fieldName="config.limitConfig.offset"
          label="Offset"
          type="number"
          slotProps={{ htmlInput: { min: 0, step: 1 } }}
          helperText="The number of objects to skip"
        />
      )}
    </Stack>
  );
}
